let cityAndAreaList = JSON.parse(sessionStorage.getItem('cityAndAreaList'));
if (!cityAndAreaList?.length) {
    getBranches()
        .then((branches) => {
            cityAndAreaList = branches.flatMap((branch) => {
                const area = branch.fields.find(field => field.key === 'area')?.value;
                const city = branch.fields.find(field => field.key === 'city')?.value;
                if (!city && !area) {
                    return [];
                }
                return { city, area };
            });
            sessionStorage.setItem('cityAndAreaList', JSON.stringify(cityAndAreaList));
            setTimeout(() => {
                sessionStorage.removeItem('cityAndAreaList');
            }, 60 * 1000);
            initFiltersOptions();
        })
        .catch(() => {
            console.log('Error getting branches data');
        })
} else {
    initAction(initFiltersOptions);
}

async function getBranches() {
    const apiUrl = '/api/2024-04/graphql.json';
    const query = `query Metaobjects {
                    metaobjects(type: "branches", first: 100) {
                        nodes {
                            fields {
                                key
                                value
                            }
                        }
                    }
                }`;

    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '4432b90b32807ab16e13ada154e746ee',
        },
        body: JSON.stringify({ query }),
    });

    const json = await response.json();
    return json.data.metaobjects.nodes
}

function initFiltersOptions() {
    const formElement = document.querySelector('form.filters');
    formElement.querySelectorAll('.branches-filter').forEach((filterWrapper) => {
        const target = filterWrapper.dataset.target;
        const optionsList = filterWrapper.querySelector('.boa-autocomplete-list');
        optionsList.innerHTML = '';
        const uniqueOptions = cityAndAreaList.reduce((acc, cityAndArea) => {
            if (acc.includes(cityAndArea[target])) {
                return acc;
            }
            acc.push(cityAndArea[target]);
            return acc;
        }, []);
        uniqueOptions.forEach((optionValue) => {
            const option = document.createElement('li');
            if (target === 'city') {
                option.dataset.area = cityAndAreaList.find(({ city }) => city === optionValue)?.area;
            }
            option.textContent = optionValue;
            option.addEventListener('click', () => {
                option.closest('.branches-filter').querySelector('input').value = optionValue;
                filterBranches(optionValue, target)
                if (target === 'area') {
                    document.querySelector('.branches-filter[data-target="city"]').querySelector('input').value = '';
                    document.querySelectorAll('.branches-filter[data-target="city"] .boa-autocomplete-list li').forEach((option) => {
                        if (option.dataset.area === optionValue) {
                            option.classList.remove('hidden');
                        } else {
                            option.classList.add('hidden');
                        }
                    });
                }
            })
            optionsList.append(option);
        })
    });
}

initAction(initFilterInputs);

function filterBranches(term, field) {
    const branchItemCollection = document.querySelectorAll('li.boa-branch-item');
    branchItemCollection.forEach((branchItem) => {
        // Show all
        if (!term && !field) {
            return branchItem.classList.remove('hidden');
        }
        const isMatch = branchItem.dataset[field].trim().toUpperCase() === term.trim().toUpperCase();
        if (isMatch) {
            branchItem.classList.remove('hidden');
        } else {
            branchItem.classList.add('hidden');
        }
    });
    document.querySelectorAll('.boa-autocomplete-list').forEach(optionsList => optionsList.classList.add('hidden'));
}

function initFilterInputs() {
  const formElement = document.querySelector("form.filters");
  formElement.querySelectorAll(".branches-filter").forEach((filterWrapper) => {
    const optionsList = filterWrapper.querySelector(".boa-autocomplete-list");

    const input = filterWrapper.querySelector("input");
    input.addEventListener("input", (e) => {
      const optionElements = optionsList.querySelectorAll("li");
            const term = e.target.value.trim().toUpperCase();
      if (term === "") {
        const target = filterWrapper.dataset.target;
        filterBranches(term, target, false);
        if (target === "area") {
          filterBranches(term, "city", false);
          resetFilters(false);
        }
        return;
      }
            let hasAtLeastOneOptionVisible = false;
            optionElements.forEach((option) => {
                const isMatch = option.textContent.trim().toUpperCase().includes(term);
                option.classList.toggle("hidden", !isMatch);
                hasAtLeastOneOptionVisible ||= isMatch;
            });
            if (hasAtLeastOneOptionVisible) {
                optionsList.classList.remove('hidden');
            } else {
                optionsList.classList.add('hidden');
            }
        });
        input.addEventListener('focus', () => {
            optionsList.classList.remove('hidden');
        });
        let mouseOverOptions = false;
        input.addEventListener('blur', () => {
            if (!mouseOverOptions) {
                optionsList.classList.add('hidden');
            }
        });
        optionsList.addEventListener('mousedown', () => {
            mouseOverOptions = true;
            setTimeout(() => {
                mouseOverOptions = false;
            });
        })
    });
  formElement
    .querySelector("#reset-filters-button")
    .addEventListener("click", resetFilters);
  formElement
    .querySelectorAll(".branches-filter-check input")
    .forEach((checkbox) =>
      checkbox.addEventListener("change", (checkbox) =>
        filterBranches(checkbox.target.name, "filters", checkbox.target.checked)
      )
    );
}


function resetFilters() {
    filterBranches();
    document.querySelectorAll('.branches-filter input').forEach((input) => {
        input.value = '';
    });
    document.querySelectorAll('.boa-autocomplete-list').forEach((optionsList) => {
        optionsList.querySelectorAll('li').forEach((optionItem) => {
            optionItem.classList.remove('hidden');
        })
    });
}

function initAction(cb) {
    if (document.readyState !== 'loading') {
        cb();
    } else {
        document.addEventListener('DOMContentLoaded', cb);
    }
};